// Display names for the concession product codes.
//
// The OPTIONS themselves are server-driven — GetConcessionUserContext returns the codes the
// approver roster carries ceilings for, so the API stays authoritative about what may be
// filed. This file only decides how each code reads on screen, and exists so the two views
// that render a product cannot drift apart.
//
// The spellings match Polly's own loan type export (its "Loan Type" column), so a product
// here reads the same as it does in Polly. HELOC is intentionally absent: it is a Polly loan
// type but the roster has no ceilings for it, so it never reaches the wire. See the note on
// ProductAliases in ConcessionDecision.cs before adding one.
const PRODUCT_LABELS = {
  conv: 'Conventional',
  fha: 'FHA',
  usda: 'USDA',
  va: 'VA',
  jumbo: 'Jumbo',
  nonqm: 'NonQM'
}

// Falls back to the raw code rather than to a guess: an unrecognized product is a real
// signal on this screen (it means the file's loan type is not one we price against), and
// showing it verbatim is how the requester knows what to fix.
export function productLabel(code) {
  return PRODUCT_LABELS[code] || code || '—'
}

export default productLabel
